export class Trigger {
    Id?: number;
    Weekdays: string; // Comma-separated values like: 'Monday,Thursday,Saturday'
    StartTime: string;
    EndTime: string;
    TimeZoneIdentifier: string;
}
